export default __webpack_public_path__ + "static/media/Empty_EmployeeOnLeaveToday.4e34c38a.svg";